import clsx from "clsx";
import { FunctionComponent } from "react";

import { liveBeacon } from "@ui/components/layout/StreamPageContent/StreamPageContent.css";

import * as styles from "./LiveBadge.css";

export interface Props {
  badgeOrientation?: "horizontal" | "vertical";
  variation?: keyof typeof styles.badge;
  className?: string;
  label?: string;
}

const LiveBadge: FunctionComponent<Props> = ({
  badgeOrientation = "horizontal",
  variation = "stream",
  className,
  label = "LIVE",
}) => {
  return (
    <span
      className={clsx(
        styles.badge[variation],
        badgeOrientation === "vertical" && styles.rotateBadge,
        className,
      )}
    >
      {variation === "post" ? (
        <span className={clsx(liveBeacon, styles.beacon)} />
      ) : null}
      <span
        className={variation === "post" ? styles.labelWithBeacon : undefined}
      >
        {label}
      </span>
    </span>
  );
};

export default LiveBadge;
